import { Navigate, Route, Routes } from 'react-router';
import { CourseById } from './pages/course-by-id';
import { TrailsById } from './pages/trails-by-id';
import { CorporateUniversity } from '.';

export const CorporateUniversityRoutes = () => {
  return (
    <Routes>
      <Route index element={<CorporateUniversity />} />
      <Route path="trilhas" element={<CorporateUniversity />} />
      <Route path="trilhas/:id" element={<TrailsById />} />
      <Route path="cursos/:id" element={<CourseById />} />
      <Route path="*" element={<Navigate to="/trilhas" replace />} />
    </Routes>
  );
};
